import { axios } from '@/utils/request'
const api = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  Register2:'/admin/register',
  adminLogin:'/admin/login',
  adminInfo:'/admin/info',//用户基本信息查询
  adminLogout:'/admin/logout',
  adminVerifycode:'/admin/verifycode',
  adminValidateCode:'/admin/validateCode',
  adminCheckCalidateCode:'/admin/checkCalidateCode',

}
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
// 登录
export function login (parameter) {
  return axios({
    url: api.adminLogin,
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: parameter,
    func:'登录'
  })
}
// 获取验证码
export function getSmsCaptcha (parameter) {
  console.log(parameter)
  return axios({
    url: api.adminVerifycode,
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: parameter,
    func:'获取验证码'
  })
}
// 用户基本信息查询
export function getInfo () {
  return axios({
    url: api.adminInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    func:'用户基本信息查询'
  })
}
// 退出登录
export function logout () {
  return axios({
    url: api.adminLogout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    func:'退出登录'
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter
  })
}
// 获取图形验证码
export function getValidateCode (parameter) {
  return axios({
    url: api.adminValidateCode,
    method: 'post',
    data: parameter,
    func:'获取图形验证码'
  })
}
// 验证图形验证码
export function checkCalidateCode (parameter) {
  return axios({
    url: api.adminCheckCalidateCode,
    method: 'post',
    data: parameter,
    func:'验证图形验证码'
  })
}
// 注册
export function Register2 (parameter) {
  return axios({
    url: api.Register2,
    method: 'post',
    data: parameter,
    func:'注册'
  })
}
